<template>
<div class="chapter">
<div class="inner_page">
<a id="page_xi"></a>
<h1 class="toctitle">CONTENTS</h1>
<h2 class="toc"><a href="#/xhtml/06_Introduction">Introduction: Watch Out, Superstar</a></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter01">Chapter 1: Admit It, Your Life Doesn’t <em class="italic">Feel</em> as Good as It <em class="italic">Looks</em></a></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter02" title="Link target outside of Sample">Chapter 2: You Don’t Know What You Don’t Know</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample">Chapter 3: The World May Be Friendlier Than You Think</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample">Chapter 4: Don’t Always Believe What You Think</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">Chapter 5: You’re <em class="italic">Not</em> Playing to Win</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">Chapter 6: Detox Your Mindset</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">Chapter 7: Find Your Purpose</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">Chapter 8: To <em class="italic">Really</em> Live on Purpose, <em class="italic">Really</em> Stop Lying</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">Chapter 9: Accept Yourself, Liberate Yourself</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample">Chapter 10: Break Up with Anger</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample">Chapter 11: Pray for a Sh*tstorm</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter12" title="Link target outside of Sample">Chapter 12: Step into Your Authentic Power</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Epilogue" title="Link target outside of Sample">Epilogue: From Restless Swan to Wild Goose</span></h2>
<h2 class="toc"><span href="#/xhtml/21_About" title="Link target outside of Sample">About the Author</span></h2>
<a id="page_xii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?3d59d446